import React, { Component, PropTypes } from 'react';
import GenericError from './generic-error.js';
import { accessibilityNotificationsEmitter } from './accessibility-notifications';
import styleable from 'react-styleable';
import defaultStyle from './common.style.js';

export class LoadingPane extends Component {

  componentWillUpdate(nextProps, nextState) {
    const { isLoading : wasLoading, loadingMessage, contentLoadedMessage } = this.props;
    const { isLoading } = nextProps;
    if(!isLoading && wasLoading) {
      accessibilityNotificationsEmitter.polite(contentLoadedMessage);
    }
    else if(!wasLoading && isLoading) {
      accessibilityNotificationsEmitter.polite(loadingMessage);
    }
  }

  render() {
    const { err, isLoading, children, loadingMessage, type, css } = this.props;

    if (err) {
      return <GenericError err={err} css={css}/>
    }

    if (isLoading) {
      return (
        <div id="loading-message" className={css.loadingMessage}>
          { loadingMessage }
        </div>
      );
    }

    /* currently using a switch case for this,
    ideally this could be changed to simply pass the html element type that should wrap the children*/
    switch(type) {
      case 'tbody':
        return <tbody>{ children }</tbody>;
      case 'div':
      default :
        return<div>{ children }</div>;
    }
  }
}

LoadingPane.defaultProps = {
  contentLoadedMessage : 'Content Loaded',
  loadingMessage : 'Loading...',
  type: 'div',
}

LoadingPane.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  err: PropTypes.object,
  loadingMessage: PropTypes.string,
  contentLoadedMessage: PropTypes.string,
  children: PropTypes.any,
  type: PropTypes.string,
};

export default styleable(defaultStyle) (LoadingPane);



// WEBPACK FOOTER //
// src/common/loading-pane.js